import { useState, useEffect, useCallback } from "react";
import Select, { MultiValue, StylesConfig } from "react-select";
import { Option } from "../../interface/Option";
import { InsuranceAxiosInstance } from "../../Network/InsuranceAxiosInstance";

const ListOfInsuranceplanName = ({ onChange, clear, defaultValue }: any) => {
  const [options, setOptions] = useState<Option[]>([]);
  const [selectedOptions, setSelectedOptions] = useState<Option[]>([]);
  const [loading, setLoading] = useState(false);
  const [inputValue, setInputValue] = useState<string>("");
  const [allOptions, setAllOptions] = useState<Option[]>([]);

  const loadAllOptions = useCallback(async () => {
    setLoading(true);
    try {
      const response = await InsuranceAxiosInstance.get("searchInsurancePlan", {
  params: { name: "", active: true },
      });

      const data = response.data?.result || [];

      const formattedOptions: Option[] = data.map((item: any) => {
        const name = item.name || item.plan_name || item.planName || item.title || `Plan ${item.id}`;
        const id = item.id || item.plan_id || "unknown";
        return {
          value: id.toString(),
          label: `(${id}) ${name}`,
        };
      });

      setAllOptions(formattedOptions);
      setOptions(formattedOptions);
    } catch (error) {
      console.error("Error loading all options:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadAllOptions();
  }, [loadAllOptions]);

  useEffect(() => {
    if (inputValue.trim().length === 0) {
      setOptions(allOptions);
      return;
    }
    if (inputValue.trim().length < 3) {
      setOptions([]);
      return;
    }
    const filtered = allOptions.filter(
      (option) =>
        option.label.toLowerCase().includes(inputValue.toLowerCase()) ||
        String(option.value).toLowerCase().includes(inputValue.toLowerCase())
    );
    setOptions(filtered);
  }, [inputValue, allOptions]);

  const handleChange = (selected: MultiValue<Option>) => {
    setSelectedOptions(selected as Option[]);
    onChange(selected as Option[]);
  };

  useEffect(() => {
    if (clear) setSelectedOptions([]);
  }, [clear]);

  useEffect(() => {
    if (defaultValue) setSelectedOptions(defaultValue);
  }, [defaultValue]);

  const customStyles: StylesConfig<Option, true> = {
    multiValue: (styles) => ({ ...styles, backgroundColor: "#007BFF", color: "#FFFFFF", borderRadius: "5px" }),
    multiValueLabel: (styles) => ({ ...styles, color: "#FFFFFF" }),
    multiValueRemove: (styles) => ({ ...styles, color: "#FFFFFF", ":hover": { backgroundColor: "#0056b3", color: "#FFFFFF" } }),
    option: (styles, { isSelected }) => ({ ...styles, backgroundColor: isSelected ? "#007BFF" : "#FFFFFF", color: isSelected ? "#FFFFFF" : "#000000", ":hover": { backgroundColor: "#0056b3", color: "#FFFFFF" } }),
  };

  return (
    <Select
      isMulti
      value={selectedOptions}
      onChange={handleChange}
      options={options}
      isLoading={loading}
      onInputChange={setInputValue}
      placeholder="Type to search or select from list..."
      styles={customStyles}
    />
  );
};

export default ListOfInsuranceplanName;